import React, { useEffect, useState } from "react";
import cn from "classnames";
import Footer from "components/Footer/Footer";
import { Link } from "react-router-dom";

import forget_dash_styles from "./forceResetPassword.module.scss";
import styles from "./signin.module.scss";
import dash_styles from "../mychargers.module.scss";
import { Auth } from "aws-amplify";

async function logIn() {
  try {
    const user = await Auth.signIn(
      "fleetboxstaging@nuvve.com",
      "@!V^f$hR08!wca@!"
    );
    // const user = await Auth.signIn(username, password);
  } catch (error) {
    console.log("error signing in", error);
  }
}

export default function ForgetResetPassword(props) {
  const [userData, setUserData] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [errorMessage, setErrorMessage] = useState({ value: "" });
  async function restPassword(newPassword) {
    try {
      // const user = await Auth.signIn("fleetboxstaging@nuvve.com", "@!V^f$hR08!wca@!");
      if (newPassword === "") {
        setErrorMessage((prevState) => ({
          value: "Empty New Password field",
        }));
      } else if (userData.confirmPassword === "") {
        setErrorMessage((prevState) => ({
          value: "Empty Confirm Password field",
        }));
      } else if (userData.confirmPassword != newPassword) {
        setErrorMessage((prevState) => ({
          value:
            "To create a valid password, both the new password and confirm password fields value must be matched.",
        }));
      } else {
        setErrorMessage((prevState) => ({
          value: "",
        }));
        const userName = await localStorage.getItem("userName");
        const password = await localStorage.getItem("userCred");
        if (userName && password) {
          const user = await Auth.signIn(userName, password);

          console.log("useruseruseruser", user);

          await Auth.completeNewPassword(
            user, // the Cognito User Object
            newPassword // the new password
            // OPTIONAL, the required attributes
            // {
            //   email: 'xxxx@example.com',
            //   phone_number: '1234567890'
            // }
          )
            .then((user) => {
              // at this time the user is logged in if no MFA required
              console.log(user);
              localStorage.removeItem("userName");
              localStorage.removeItem("userCred");
              const { accessToken } = user?.signInUserSession;
              //Signin Success
              localStorage.setItem("userName", userName);
              localStorage.setItem("isLogin", true);
              localStorage.setItem("accessToken", accessToken.jwtToken);
              window.location.pathname = "/myFleet";
            })
            .catch((e) => {
              console.log(e);
              setErrorMessage((prevState) => ({
                value: "Error in resetting new Password",
              }));
            });
        } else {
          window.location.pathname = "/signin";
        }
      }
    } catch (error) {
      console.log("error signing in", error);
      // //If credentials entered is invalid
      setErrorMessage((prevState) => ({
        value: "Error in resetting new Password",
      }));
    }
  }

  const handleInputChange = (e) => {
    setUserData((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    restPassword(userData.newPassword);
    //if username field is empty, return error message
  };

  return (
    <div className={`ldpg ${cn(dash_styles.main, dash_styles.main_layout)}`}>
      <div className={cn(dash_styles.main_flex, forget_dash_styles.main_flex)}>
        <img
          src={require("assets/logo.png").default}
          alt="Rectangle 1"
          className={cn(
            styles.username_logo_boxl,
            styles.username_logo_boxl_layout
          )}
        />

        <form onSubmit={handleSubmit}>
          <div
            className={cn(styles.panel_group, styles.forget_panel_group_layout)}
          >
            {errorMessage.value !== "" && (
              <p className={cn(styles.error)}> {errorMessage.value} </p>
            )}

            <div className={cn(styles.username, styles.username_layout)}>
              <h1>{"Enter new password"}</h1>
              <input
                type="password"
                name="newPassword"
                onChange={(e) => handleInputChange(e)}
                className={cn(
                  styles.forgot_username_box,
                  styles.forgot_username_box_layout
                )}
              />
            </div>

            <div className={cn(styles.username, styles.username_layout)}>
              <h1>{"Confirm new password"}</h1>
              <input
                type="password"
                name="confirmPassword"
                onChange={(e) => handleInputChange(e)}
                className={cn(
                  styles.forgot_username_box,
                  styles.forgot_username_box_layout
                )}
              />
            </div>

            <h3
              className={cn(
                styles.return_login_text,
                styles.return_login_text_layout
              )}
            >
              <Link to="/signin" className={cn(styles.return_login_text2)}>
                Back to login
              </Link>
            </h3>
            <button
              type="submit"
              className={cn(
                styles.panel_group_big_title3,
                styles.panel_group_big_title_layout3,
                styles.panel_group_block,
                styles.panel_group_block_layout
              )}
            >
              {/* disabled={!userData.userName}  */}
              {"Submit"}
            </button>
          </div>
        </form>
        <Footer></Footer>
      </div>
    </div>
  );
}

ForgetResetPassword.inStorybook = true;
